import { Grid2, Skeleton } from "@mui/material";
import useLanguage from "../../hooks/useLanguage";
import CommonPage from "../../components/common-page";

const StreamSkeleton = () => {
  const [
    {
      pages: { stream: text },
    },
  ] = useLanguage();

  return (
    <CommonPage title={text.title} subtitle={text.subtitle}>
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <Skeleton variant="rounded" width="100%" height={400} />
        </Grid2>
        <Grid2 size={12}>
          <Skeleton variant="rounded" width="100%" height={360} />
        </Grid2>
      </Grid2>
    </CommonPage>
  );
};

export default StreamSkeleton;
